import { isEmptyObject } from '../modules/utilities.js'

export const getNotEmptyString = (str, elm = 'unknown element', log = false) => {
   if (typeof str === 'string' && str.length > 0) {
      return str
   } else {
      if (typeof str === 'undefined') {
         if (log === false) {
            throw `"${elm}": key is undefined`
         } else {
            console.error(`"${elm}": key is undefined`)
         }
      } else if (typeof str !== 'string') {
         if (log === false) {
            throw `"${elm}": value is not a valid string`
         } else {
            console.error(`"${elm}": value is not a valid string`)
         }
      } else if (str.length === 0) {
        if (log === false) {
           throw `"${elm}": value is an empty string`
        } else {
           console.error(`"${elm}": value is an empty string`)
        }
      }
   }
}

export const getString = (str, elm = 'unknown element', log = false) => {
   if (typeof str === 'string') {
      return str
   } else {
      if (typeof str === 'undefined') {
         if (log === false) {
            throw `"${elm}": key is undefined`
         } else {
            console.error(`"${elm}": key is undefined`)
         }
      } else {
         if (log === false) {
            throw `"${elm}": value is not a string`
         } else {
            console.error(`"${elm}": value is not a string`)
         }
      }
   }
}

export const validateAnalyticsGA = (analytics, comment='') => {
  getNotEmptyString(analytics.pdbZid, 'pdbZid ' + comment)
  getNotEmptyString(analytics.pdbSc, 'pdbSc ' + comment)
  getNotEmptyString(analytics.pdbIdc, 'pdbIdc ' + comment)
  getString(analytics.pdbVi, 'pdbVi ' + comment)
  getNotEmptyString(analytics.oeventCategory, 'oeventCategory ' + comment)
  getNotEmptyString(analytics.oeventAction, 'oeventAction ' + comment)
  getNotEmptyString(analytics.oeventLabel, 'oeventLabel ' + comment)
  getNotEmptyString(analytics.oeventOther, 'oeventOther ' + comment)
}

export const getNotEmptyObject = (obj, errorMsg = 'getNotEmptyObject error', log = false) => {
   if (isEmptyObject(obj) === false && typeof obj === 'object') {
      return obj
   } else if (log === false) {
      throw errorMsg
   } else {
      console.error(errorMsg)
   }
}

export const getObject = (obj, errorMsg = 'getObject error', log = false) => {
   if (typeof obj === 'object') {
      return obj
   } else if (log === false) {
      throw errorMsg
   } else {
      console.error(errorMsg)
   }
}

export const isObject = (obj) => {
   if (typeof obj === 'object') {
      return true
   } else {
      return false
   }
}

export const arrayHasNitems = (arr, nbItems, errorMsg) => {
   if (Array.isArray(arr) && arr.length === nbItems) {
      return true
   } else {
      throw errorMsg
   }
}

export const arrayHasMinNitems = (arr, nbItems, errorMsg) => {
   if (Array.isArray(arr) && arr.length >= nbItems) {
      return true
   } else {
      throw errorMsg
   }
}

export const stringMatchWith = (str, list = [], errorMsg) => {
   let match = false
   for (const item of list) {
      if (item === str) match = true
   }
   if (match) {
      return str
   } else {
      throw errorMsg
   }
}
